export function TypingDots() {
  return (
    <div className="self-start flex gap-1 px-3.5 py-2.5 mt-0.5 mb-2 bg-tg-bubble-in rounded-[12px_12px_12px_4px]">
      {[0, 1, 2].map((i) => (
        <span
          key={i}
          className="size-1.5 rounded-full bg-tg-text-muted"
          style={{ animation: `ss-typing 1.2s ${i * 0.15}s infinite` }}
        />
      ))}
    </div>
  );
}
